/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { DataTableComponent } from "../../../shared/components/data-table/data-table.component";
import { DataTable } from "../../../shared/components/data-table/data-table.type";
import { DeleteModalComponent } from "../../../shared/components/delete-modal/delete-modal.component";
import { UserInfo } from "../../../shared/types/user-info";
import { Location } from "./location.type";
import { LocationTableService } from "./location-table.service";

@Component({
  selector: "app-locations",
  templateUrl: "./locations.component.html",
  styleUrls: ["./locations.component.scss"],
})
export class LocationsComponent implements OnInit {
  @ViewChild(DataTableComponent) dataTableComponent: DataTableComponent<Location>;
  currentUser: UserInfo;
  tableConfig: DataTable<Location>;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DeleteModalComponent>,
    private router: Router,
    private authenticationService: AuthenticationService,
    public locationTableService: LocationTableService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  // #region Life cycle method

  ngOnInit(): void {
    this.tableConfig = this.locationTableService.getLocationsTableConfig();
  }

  // #endregion

  // #region Handlers

  onAddLocation(): void {
    this.addLocation();
  }

  // #endregion

  // #region Private methods

  private addLocation(): void {
    this.router.navigate(["/locations/create"]);
  }

  // #endregion
}
